import DataTable from '../../ui/DataTable'
import type { Column } from '../../ui/DataTable'
import Flag from '../../ui/Flag'
import { distanceKm } from '../../lib/geo'
import { formatAsn, formatDistance, formatPercent, sharePercent } from '../../lib/format'
import type { DnsechoRow, IpDetails } from '@shared/api'

interface ResolverTableProps {
    rows: DnsechoRow[]
    self: IpDetails | undefined
}

export default function ResolverTable({ rows, self }: ResolverTableProps) {
    // share is of *observed* queries: the total can exceed 50 when resolvers retry
    const total = rows.reduce((sum, r) => sum + r.count, 0)
    const sorted = [...rows].sort((a, b) => b.count - a.count)

    const columns: Column<DnsechoRow>[] = [
        { key: 'ip', header: 'Resolver', render: (r) => r.ip },
        {
            key: 'share', header: 'Share', numeric: true,
            render: (r) => formatPercent(sharePercent(r.count, total)),
        },
        { key: 'city', header: 'City', render: (r) => r.cityName ?? '—' },
        {
            key: 'country', header: 'Country',
            render: (r) => <Flag cc={r.cc} name={r.countryName ?? r.cc} />,
        },
        { key: 'operator', header: 'Operator', render: (r) => r.asnOrg ?? r.isp ?? '—' },
        { key: 'asn', header: 'ASN', render: (r) => formatAsn(r.asnNumber) },
        {
            key: 'distance', header: 'Distance', numeric: true,
            render: (r) => formatDistance(distanceKm(self?.location, r.location)),
        },
    ]

    return (
        <DataTable
            columns={columns}
            rows={sorted}
            rowKey={(r) => r.ip}
            caption="Resolvers that answered for you, by share of observed queries"
            empty="No resolvers observed yet."
        />
    )
}
